import axios from 'axios'
import { BUSCAR_USUARIO_POR_PARTE } from '../types'
import { URL } from '../../util/ambienteActions';

export default function buscarUsuarioPorEmpresaNomeIdEmail (nome, empresaId) {
    const url = `${URL}/usuarios/${nome}/empresa/${empresaId}`;
  return dispatch => axios.get(url).then(
      response => dispatch({
          type: BUSCAR_USUARIO_POR_PARTE,
        payload: response

      })
  );
}
